// extracted by mini-css-extract-plugin
var _1 = "BuildingTableLayout-modulepageActions__caELh PageActions-modulePageActions__lL8Sl";
export { _1 as "pageActions" }
